<header></header>
<router-outlet></router-outlet>



<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac5cbc47077cbc5a1dc052692d3031fa205ece3c7b03708f61c2d8153d749b848&amp;source=constructor" width="100%" height="400" frameborder="0"></iframe>
